import React from 'react';
import TextWithTooltip from '../../../../../../../../../components/TextWithTooltip/TextWithTooltip';
import BlockWithExtraContent from '../../../../../../../../../components/BlockWithExtraContent/BlockWithExtraContent';
import getName from '../../../../../../../../../helpers/getName';
import { getTooltipTitleForWorker } from '../../../../../../../shared/lib/utils';

const Item = ({ item, additionalTooltipTitle, parentWidth, ...props }) => {
  return (
    <TextWithTooltip
      {...props}
      parentWidth={parentWidth}
      mainTitle={getTooltipTitleForWorker(item)}
      additionalTitle={additionalTooltipTitle}
      render={({ textRef, ...renderProps }) => (
        <BlockWithExtraContent
          ref={textRef}
          main={getName(item)}
          extra={item.specialityName || item.speciality}
          {...renderProps}
        />
      )}
    />
  );
};

export default Item;
